import { service } from '@ember/service'
import { isEmpty } from '@ember/utils'
import Route from '@ember/routing/route'
import type TeacherService from 'teacher-ui-client/services/teacher'
import type RouterService from '@ember/routing/router-service'

export default class ManageImportTeachersRoute extends Route {
  @service teacher!: TeacherService

  @service router!: RouterService

  beforeModel() {
    const hasNoCsvFile = isEmpty(this.teacher.file)
    if (hasNoCsvFile) void this.router.replaceWith('manage.teachers')
  }
}
